import { useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';

import { Link, Wrapper } from './header.styles';

import AvatarWithMarker from '../../common/avatar_with_marker';
import VendorLogo from '../../common/vendor_logo';

import { currentUserState } from '../../../store';

export default function Header() {
  const currentUser = useAtomValue(currentUserState);
  const profileString = useTranslation('Profile');

  return (
    <Wrapper>
      <VendorLogo />
      <Link aria-label={profileString} to="/profile">
        <AvatarWithMarker size={60} user={currentUser} />
      </Link>
    </Wrapper>
  );
}
